import React, { useEffect, useState } from 'react';
import api from '../services/ApiService';

type PauseReason = {
  id: number;
  reason_code: string;
  reason_name: string;
};

export default function AgentStatePanel() {
  const [state, setState] = useState('offline');
  const [pauseReasons, setPauseReasons] = useState<PauseReason[]>([]);
  const [pauseReason, setPauseReason] = useState('');
  const [queueName, setQueueName] = useState('support');

  const loadPauseReasons = async () => {
    try {
      const data = await api.getPauseReasons();
      setPauseReasons(data);

      if (data.length > 0) {
        setPauseReason(data[0].reason_code);
      }
    } catch (e) {
      console.error(e);
    }
  };

  useEffect(() => {
    loadPauseReasons();
  }, []);

  const updateState = async (newState: string) => {
    try {
      await api.updateAgentState({
        state: newState,
        pause_reason:
          newState === 'paused'
            ? pauseReason
            : null,
        queue_name: queueName
      });

      setState(newState);

      alert(`Agent state updated to ${newState}`);
    } catch (e) {
      console.error(e);
      alert('Failed to update state');
    }
  };

  return (
    <div className="content-card">
      <h3>Agent State</h3>

      <div className="admin-form-row">
        <select
          className="admin-select"
          value={queueName}
          onChange={(e) =>
            setQueueName(e.target.value)
          }
        >
          <option value="support">
            support
          </option>

          <option value="sales">
            sales
          </option>
        </select>

        <select
          className="admin-select"
          value={pauseReason}
          onChange={(e) =>
            setPauseReason(e.target.value)
          }
        >
          {pauseReasons.map((r) => (
            <option
              key={r.id}
              value={r.reason_code}
            >
              {r.reason_name}
            </option>
          ))}
        </select>
      </div>

      <div
        style={{
          display: 'flex',
          gap: '10px',
          marginTop: '20px',
          flexWrap: 'wrap'
        }}
      >
        <button
          className="primary-btn"
          onClick={() =>
            updateState('ready')
          }
        >
          Ready
        </button>

        <button
          className="secondary-btn"
          onClick={() =>
            updateState('busy')
          }
        >
          Busy
        </button>

        <button
          className="warning-btn"
          onClick={() =>
            updateState('paused')
          }
        >
          Pause
        </button>

        <button
          className="danger-btn"
          onClick={() =>
            updateState('offline')
          }
        >
          Offline
        </button>
      </div>

      <div
        style={{
          marginTop: '20px',
          fontWeight: 700
        }}
      >
        Current State: {state}
      </div>
    </div>
  );
}